import { render, staticRenderFns } from "./PDPQuestionModal.vue?vue&type=template&id=e7e26898&scoped=true&"
import script from "./PDPQuestionModal.vue?vue&type=script&lang=js&"
export * from "./PDPQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./PDPQuestionModal.vue?vue&type=style&index=0&id=e7e26898&prod&lang=scss&"
import style1 from "./PDPQuestionModal.vue?vue&type=style&index=1&id=e7e26898&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e26898",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
